import { takeLatest, call, put } from 'redux-saga/effects';
import api from '../../api/index';
import {
  GET_DASHBOARD_LIST, SET_DASHBOARD_LIST, DASHBOARD_LIST_REQUEST_FAILED, SENDING_DASHBOARD_LIST_REQUEST,
} from '../../types/Types';

/**
 * Call the api and dispatch data to the reducer
 * @param { Object } action Contained object data to be send to API call
 */
export function* getDashboardList(action) {
  const { data } = action;
  // console.log(data);
  try {
    yield put({
      type: SENDING_DASHBOARD_LIST_REQUEST,
      dashboardListData: '',
      isDLSending: true,
      isDLSuccess: false,
      dLError: false,
    });
    const response = yield call(api.dashboard.getDashboardList, data);
    // console.log(response);
    if (response && response.Dashboards) {
      // console.log('inside');
      yield put({
        type: SET_DASHBOARD_LIST,
        dashboardListData: response.Dashboards,
        isDLSending: false,
        dLError: false,
        isDLSuccess: true,
      });
    } else {
      yield put({
        type: DASHBOARD_LIST_REQUEST_FAILED,
        dashboardListData: null,
        isDLSending: false,
        dLError: true,
        isDLSuccess: false,
        fMsg: response.errorMsg,
      });
    }
  } catch (e) {
    yield put({
      type: DASHBOARD_LIST_REQUEST_FAILED,
      fMsg: e.message,
      isDLSending: false,
      dLError: true,
      isDLSuccess: false,
      dashboardListData: null,
    });
  }
}

/**
 * map the dispatched action to the above function
 */
export default function* watchGetDashboardList() {
  yield takeLatest(GET_DASHBOARD_LIST, getDashboardList);
}
